export default "__VITE_ASSET__db46c7c7__"